import React, { useState } from 'react';

const App = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [indonesianInput, setIndonesianInput] = useState('');
  const [videoQuality, setVideoQuality] = useState('');
  const [additionalDetails, setAdditionalDetails] = useState('');

  const [gender, setGender] = useState('');
  const [age, setAge] = useState('');
  const [emotion, setEmotion] = useState('');
  const [clothing, setClothing] = useState('');
  const [accessories, setAccessories] = useState('');

  const [location, setLocation] = useState('');
  const [weather, setWeather] = useState('');
  const [season, setSeason] = useState('');
  const [time, setTime] = useState('');

  const [cameraStyle, setCameraStyle] = useState('');
  const [cameraMovement, setCameraMovement] = useState('');
  const [cameraFocus, setCameraFocus] = useState('');
  const [cameraAngle, setCameraAngle] = useState('');

  const [music, setMusic] = useState('');
  const [sound, setSound] = useState('');
  const [voiceMood, setVoiceMood] = useState('');

  const [generatedIndonesianPrompt, setGeneratedIndonesianPrompt] = useState('');
  const [generatedEnglishPrompt, setGeneratedEnglishPrompt] = useState('');
  const [copyStatusIndonesian, setCopyStatusIndonesian] = useState('');
  const [copyStatusEnglish, setCopyStatusEnglish] = useState('');

  const handleGenerate = () => {
    setLoading(true);
    setTimeout(() => {
      const indo = `Judul Video: ${indonesianInput}\nKualitas: ${videoQuality}\nDetail Tambahan: ${additionalDetails}\n\nKarakter: ${gender}, ${age}, ${emotion}, pakaian: ${clothing}, aksesori: ${accessories}\nLatar: ${location}, ${weather}, ${season}, ${time}\nKamera: Gaya: ${cameraStyle}, Gerakan: ${cameraMovement}, Fokus: ${cameraFocus}, Sudut: ${cameraAngle}\nAudio: Musik: ${music}, Suara: ${sound}, Suasana Suara: ${voiceMood}`;

      const eng = `Video Title: ${indonesianInput}\nQuality: ${videoQuality}\nAdditional Details: ${additionalDetails}\n\nCharacter: ${gender}, ${age}, ${emotion}, clothing: ${clothing}, accessories: ${accessories}\nSetting: ${location}, ${weather}, ${season}, ${time}\nCamera: Style: ${cameraStyle}, Movement: ${cameraMovement}, Focus: ${cameraFocus}, Angle: ${cameraAngle}\nAudio: Music: ${music}, Sound: ${sound}, Voice Mood: ${voiceMood}`;

      setGeneratedIndonesianPrompt(indo);
      setGeneratedEnglishPrompt(eng);
      setLoading(false);
    }, 1200);
  };

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text).then(() => {
      if (type === 'id') setCopyStatusIndonesian('✅ Tersalin!');
      if (type === 'en') setCopyStatusEnglish('✅ Copied!');
      setTimeout(() => {
        setCopyStatusIndonesian('');
        setCopyStatusEnglish('');
      }, 2000);
    });
  };

  return (
    <div className={darkMode ? 'dark bg-gray-900 text-white min-h-screen' : 'bg-white text-gray-900 min-h-screen'}>
      <header className="flex items-center justify-between px-6 py-4 bg-green-800 text-white shadow">
        <div className="flex items-center gap-3">
          <img src="https://allsolution.biz.id/gambarbebas/20250711-112336_omahelwolu%20logo%20gold.png" alt="Logo" className="h-10 w-auto" />
          <h1 className="text-2xl font-bold tracking-wide">Veo3 Prompt Generator</h1>
        </div>
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="text-sm px-3 py-1 border border-white rounded hover:bg-white hover:text-green-800 transition"
        >
          {darkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}
        </button>
      </header>

      <main className="max-w-5xl mx-auto px-4 py-8">
        <section className="grid md:grid-cols-2 gap-4">
          <InputBlock label="Deskripsi Video" value={indonesianInput} onChange={setIndonesianInput} textarea placeholder="Contoh: Seorang pria sedang memegang produk di tengah hutan pagi hari..." />
          <InputBlock label="Kualitas Video" value={videoQuality} onChange={setVideoQuality} placeholder="Contoh: 4K, sinematik, realistis" />
          <InputBlock label="Detail Tambahan" value={additionalDetails} onChange={setAdditionalDetails} textarea placeholder="Contoh: Warna kontras tinggi, efek dramatis, slow motion..." />
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold mb-2">Karakter</h2>
          <div className="grid md:grid-cols-3 gap-4">
            <SelectBlock label="Gender" value={gender} onChange={setGender} options={["", "Pria", "Wanita"]} />
            <InputBlock label="Usia" value={age} onChange={setAge} />
            <SelectBlock label="Emosi" value={emotion} onChange={setEmotion} options={["", "Bahagia", "Serius", "Sedih", "Marah"]} />
            <InputBlock label="Pakaian" value={clothing} onChange={setClothing} />
            <InputBlock label="Aksesori" value={accessories} onChange={setAccessories} />
          </div>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold mb-2">Latar</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <SelectBlock label="Lokasi" value={location} onChange={setLocation} options={["", "Kota", "Hutan", "Pantai", "Pegunungan", "Ruang Tamu"]} />
            <SelectBlock label="Cuaca" value={weather} onChange={setWeather} options={["", "Cerah", "Mendung", "Hujan", "Kabut"]} />
            <SelectBlock label="Musim" value={season} onChange={setSeason} options={["", "Kemarau", "Hujan", "Dingin", "Panas"]} />
            <SelectBlock label="Waktu" value={time} onChange={setTime} options={["", "Pagi", "Siang", "Sore", "Malam"]} />
          </div>
        </section>

        <section className="mt-6">
          <h2 className="text-xl font-semibold mb-2">Kamera & Audio</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <SelectBlock label="Gaya Kamera" value={cameraStyle} onChange={setCameraStyle} options={["", "Sinematik", "Dokumenter", "DSLR"]} />
            <SelectBlock label="Gerakan Kamera" value={cameraMovement} onChange={setCameraMovement} options={["", "Zoom", "Crane", "Tracking Shot"]} />
            <SelectBlock label="Fokus Kamera" value={cameraFocus} onChange={setCameraFocus} options={["", "Produk", "Wajah", "Latar Belakang"]} />
            <SelectBlock label="Sudut Kamera" value={cameraAngle} onChange={setCameraAngle} options={["", "Low Angle", "Eye Level", "High Angle"]} />
            <SelectBlock label="Musik" value={music} onChange={setMusic} options={["", "Piano", "Orkestra", "Hip-hop"]} />
            <SelectBlock label="Suara Alam" value={sound} onChange={setSound} options={["", "Alam", "Kota", "Pantai"]} />
            <SelectBlock label="Mood Suara" value={voiceMood} onChange={setVoiceMood} options={["", "Dramatis", "Tenang", "Semangat"]} />
          </div>
        </section>

        <div className="text-center my-8">
          <button
            onClick={handleGenerate}
            className="bg-green-800 text-white px-8 py-3 rounded-lg text-lg hover:bg-green-700 transition-all shadow-lg transform hover:scale-105"
          >
            🎬 Generate Prompt
          </button>
          {loading && <div className="mt-2 text-sm text-gray-500 animate-pulse">⏳ Membuat prompt...</div>}
        </div>

        {generatedIndonesianPrompt && (
          <div className="bg-green-50 dark:bg-green-900 border-l-4 border-green-600 p-4 rounded mb-6">
            <h2 className="text-lg font-bold mb-2">Prompt Bahasa Indonesia</h2>
            <pre className="whitespace-pre-wrap font-mono text-sm mb-2">{generatedIndonesianPrompt}</pre>
            <button onClick={() => handleCopy(generatedIndonesianPrompt, 'id')} className="text-sm text-green-800 hover:underline">📋 Salin</button>
            <span className="ml-2 text-green-600 text-sm">{copyStatusIndonesian}</span>
          </div>
        )}

        {generatedEnglishPrompt && (
          <div className="bg-green-100 dark:bg-green-950 border-l-4 border-green-700 p-4 rounded">
            <h2 className="text-lg font-bold mb-2">English Prompt</h2>
            <pre className="whitespace-pre-wrap font-mono text-sm mb-2">{generatedEnglishPrompt}</pre>
            <button onClick={() => handleCopy(generatedEnglishPrompt, 'en')} className="text-sm text-green-800 hover:underline">📋 Copy</button>
            <span className="ml-2 text-green-600 text-sm">{copyStatusEnglish}</span>
          </div>
        )}
      </main>

      <footer className="text-center py-4 text-sm bg-green-900 text-white">
        © 2025 by portal.omahelwolu - Prompt Generator – Made with ❤️
      </footer>
    </div>
  );
};

const InputBlock = ({ label, value, onChange, textarea, placeholder }) => (
  <div>
    <label className="block mb-1 font-semibold">{label}</label>
    {textarea ? (
      <textarea
        className="w-full border rounded p-2 dark:bg-gray-800 dark:text-white"
        rows={3}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
    ) : (
      <input
        type="text"
        className="w-full border rounded p-2 dark:bg-gray-800 dark:text-white"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
    )}
  </div>
);

const SelectBlock = ({ label, value, onChange, options }) => (
  <div>
    <label className="block mb-1 font-semibold">{label}</label>
    <input
      list={label}
      value={value}
      onChange={e => onChange(e.target.value)}
      className="w-full border rounded p-2 dark:bg-gray-800 dark:text-white"
    />
    <datalist id={label}>
      {options.map((opt, index) => (
        <option key={index} value={opt} />
      ))}
    </datalist>
  </div>
);

export default App;
